

<div class="page-wrapper">
  <app-header ></app-header>

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>

  <app-footer></app-footer>
</div>